import { MouseEvent } from 'react'
import { Avatar, Button } from '@mui/material'
import { initialsOf } from '@/shared/utils/initials'
import { avatarStyles, getAccountButtonStyles } from './AccountButton.styles'
import styles from './AccountButton.module.scss'

interface AccountButtonProps {
  name: string
  photoUrl?: string | null
  /** Avatar only, for the collapsed sidebar. */
  collapsed?: boolean
  /** The menu it opens is showing. */
  active?: boolean
  ariaLabel: string
  menuId?: string
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
}

function AccountButton(props: AccountButtonProps) {
  const {
    name,
    photoUrl,
    collapsed,
    active,
    ariaLabel,
    menuId,
    onClick
  } = props
  const initials = initialsOf(name)
  // The sidebar leaves the text about 70px; a full name would always be cut,
  // so the button greets by first name, as Claude's does.
  const firstName = name.split(' ')[0]

  return (
    <Button
      sx={getAccountButtonStyles(active, collapsed)}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-haspopup="menu"
      aria-expanded={active}
      aria-controls={active ? menuId : undefined}
      disableRipple
    >
      <Avatar src={photoUrl ?? undefined} alt={name} sx={avatarStyles}>
        {initials ? (
          <span className="body-bold-small">{initials}</span>
        ) : (
          <i className="las la-user icon-medium" />
        )}
      </Avatar>
      {!collapsed && (
        <>
          <span className={`${styles.name} body-bold-medium`}>{firstName}</span>
          {/* Says there is a menu behind the name; turns while it is open,
              as the sidebar's submenu chevrons do. */}
          <i
            className={`las la-angle-down icon-small ${styles.chevron} ${
              active ? styles.chevronOpen : ''
            }`}
            aria-hidden
          />
        </>
      )}
    </Button>
  )
}

export default AccountButton
